var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{attrs:{"id":"branding-nav"}},[_c('ul',{staticClass:"nav nav-pills"},[_c('li',[_c('router-link',{attrs:{"to":{ name: 'branding_templates' }}},[_vm._v("Templates")])],1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('router-link',{attrs:{"to":{
          name: 'import_contributors'
        }}},[_vm._v("\n        Import Contributors\n      ")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a11bf9ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BrandingNav.vue
// module id = 1260
// module chunks = 1